import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './LaunchScreen.scss';
import baseUrl from 'shared/util/baseUrl';

const LaunchScreen = ({ isVisible }) => {
  const statusBarClass = 'status-bar--launch';
  useEffect(() => {
    if (isVisible) {
      document.body.classList.add(statusBarClass);
    } else {
      document.body.classList.remove(statusBarClass);
    }
  }, [isVisible]);

  return <div className={`nw-launch-screen ${isVisible ? '' : 'hidden'}`} style={{ backgroundImage: `url(${baseUrl}/images/launch-screen.png)` }} />;
};

LaunchScreen.propTypes = {
  isVisible: PropTypes.bool,
};

LaunchScreen.defaultProps = {
  isVisible: false,
};

export default LaunchScreen;
